import { render, staticRenderFns } from "./customize-settings-page.vue?vue&type=template&id=23e5afb5&"
import script from "./customize-settings-page.vue?vue&type=script&lang=js&"
export * from "./customize-settings-page.vue?vue&type=script&lang=js&"
import style0 from "./customize-settings-page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports